import { useI18n } from 'vue-i18n'
import columnStore from '@/stores/column'

export default function useUserColumns(component: string) {
	const i18n = useI18n()
	const cols = columnStore()

	const instance = cols.define(component, 'instance_id', i18n.t('institution'), true)
	const firstname = cols.define(component, 'firstname', i18n.t('firstname'), true)
	const lastname = cols.define(component, 'lastname', i18n.t('lastname'), true)
	const idCode = cols.define(component, 'idCode', i18n.t('idCode'), true)
	const email = cols.define(component, 'email', i18n.t('email'), true)
	const aduser = cols.define(component, 'adUser', i18n.t('adUser'), false)
	const active = cols.define(component, 'active', i18n.t('active'), true)
	const roles = cols.define(component, 'roles', i18n.t('role', 2), true)
	const columns = { instance, firstname, lastname, idCode, email, aduser, active, roles }

	const { custom, all } = cols.finalize(component, columns, true, ['users'])

	return { columns, custom, all }
}
